import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG } from './constants';
export function FinalCTA() {
  return <section className="bg-brand-carbon px-4 py-6 text-white" data-id="element-51" data-mp="3udyh9qdhwlk3">
      <div className="mx-auto max-w-2xl text-center" data-id="element-52" data-mp="c7agudte4mkr">
        <p className="mb-1 font-cond text-[12px] font-bold uppercase tracking-[0.2em] text-brand-yellow sm:text-sm" data-id="element-53" data-mp="c4o8ibyoe31h">
          One Last Question
        </p>
        <h2 className="mb-1.5 font-display text-[20px] leading-tight text-white sm:text-3xl" data-id="element-54" data-mp="m3wy6smicvi1">
          When a diesel engine comes in with a fault… do you immediately know what to test first?
        </h2>
        <p className="mb-3 text-[13px] font-medium leading-snug text-brand-line sm:text-base" data-id="element-55" data-mp="vtqbpz67nkox">
          Stop jumping between possible causes. Open the system. Find the symptom. Follow the
          diagnostic path.{' '}
          <span className="font-bold text-white" data-id="element-56" data-mp="14vpr6n1kugpr">Scan. Test. Diagnose.</span>
        </p>

        <a href={CHECKOUT_URL} className="mb-3 block cursor-pointer" aria-label="Buy Diesel Diagnostic Pro" data-id="element-57" data-mp="zxy0fwco50n5">
          <img src={PRODUCT_IMG} alt="Diesel Diagnostic Pro 6-in-1 system box set" className="mx-auto w-full max-w-[220px] object-contain drop-shadow-2xl transition-transform duration-150 ease-out hover:scale-[1.02]" data-id="element-58" data-mp="2c6hioe5rnvf9" />
        </a>

        <p className="font-display text-[19px] leading-tight text-brand-yellow sm:text-2xl" data-id="element-59" data-mp="2r1xi6yp48jj1">
          🔧 DIESEL DIAGNOSTIC PRO™
        </p>
        <p className="font-cond text-[13px] font-semibold uppercase leading-snug text-brand-line sm:text-base" data-id="element-60" data-mp="2v2hfc29ovn56">
          The Complete Visual Fault-Finding System for Diesel Technicians
        </p>
        <p className="mb-3 font-cond text-[12px] font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-61" data-mp="34uddtefotf9x">
          Workflow • Fuel • Turbo • Electronics • Emissions • Faults
        </p>

        <p className="mb-2 font-cond text-[14px] font-bold uppercase tracking-wide text-brand-yellow sm:text-lg" data-id="element-62" data-mp="3esb03wdzl1zw">
          🔥 Get the complete system today
        </p>
        <CTAButton href={CHECKOUT_URL} className="mx-auto max-w-md" data-id="element-63" data-mp="1jocz6h9iv5y4">
          🔧 GET DIESEL DIAGNOSTIC PRO™
        </CTAButton>
        <p className="mt-2 text-[12px] font-semibold text-brand-line" data-id="element-64" data-mp="1eq1pc6j88vfw">
          Immediate Access • Digital Delivery · 🛡️ 7-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}